import { connect } from "react-redux";
import AboutObservable from "../../components/project-pages/AboutObservable";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(AboutObservable);
